import { useEffect } from "react";
import { useQuery } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { GET_EFFECTIVE_LANGUAGE } from "@lytra/frontend-common";

/**
 * Applies the current user's effective UI language on load.
 *
 * The backend resolves `effectiveLanguage` as: per-user override
 * (User.language) -> tenant/global `ui.language` default. Mounted inside the
 * authenticated Apollo provider so the query is authorized.
 */
export function LanguageSync() {
  const { i18n } = useTranslation();
  const { data } = useQuery(GET_EFFECTIVE_LANGUAGE);

  useEffect(() => {
    if (!data?.effectiveLanguage) return;
    const lang = ["de", "en"].includes(data.effectiveLanguage) ? data.effectiveLanguage : "de";
    if (i18n.language !== lang) void i18n.changeLanguage(lang);
  }, [data, i18n]);

  return null;
}
